"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginFormWithExtensionNightly = exports.LoginFormWithExtension = exports.LoginFormWithPassword = exports.LoginForm = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = __importStar(require("react"));
var semantic_ui_react_1 = require("semantic-ui-react");
var react_router_1 = require("react-router");
var platform = __importStar(require("platform"));
var i18n_1 = __importDefault(require("../i18n"));
var api_1 = require("../api");
var util_1 = require("../util");
var sentry_1 = require("../sentry");
var descriptionTextStyle = {
    wordWrap: "break-word",
    overflowWrap: "break-word",
    whiteSpace: "pre-wrap",
    lineHeight: "200%",
    fontSize: "smaller",
};
var extensionTextStyle = __assign(__assign({}, descriptionTextStyle), { color: "#960" });
var cautionTextStyle = __assign(__assign({}, descriptionTextStyle), { color: "#900" });
var cautionTitleTextStyle = __assign(__assign({}, cautionTextStyle), { fontWeight: "bold" });
function majorVersion(versionString) {
    if (!versionString)
        return 0;
    var match = /(^\d+)/.exec(versionString);
    return match ? Number(match[1]) : 0;
}
var extensionPlatforms = {
    Firefox: "Firefox",
    Chrome: "Chrome",
    "Microsoft Edge": "Chrome",
    // "Firefox Mobile": "Firefox",
};
var cannotUseSecureAlternativeFamilies = {
    Android: true,
    iOS: true,
    "Windows Phone": true,
};
var LoginForm = function LoginForm(state) {
    var ua = React.useMemo(function () { return platform.parse(); }, []);
    var canUseSecureLogin = React.useMemo(function () {
        var _a, _b;
        return (ua.name === "Firefox" && majorVersion(ua.version) >= 48) ||
            (ua.name === "Chrome" && ((_a = ua.os) === null || _a === void 0 ? void 0 : _a.family) === "Windows") ||
            (ua.name === "Microsoft Edge" &&
                ((_b = ua.os) === null || _b === void 0 ? void 0 : _b.family) === "Windows" &&
                majorVersion(ua.version) >=
                    14);
    } /* ||
(ua.name === "Firefox Mobile" && majorVersion(ua.version) >= 54) ||
false */, [ua]);
    var extensionPlatform = React.useMemo(function () { return extensionPlatforms[ua.name]; }, [ua]);
    var _a = React.useState(canUseSecureLogin), secureLoginEnabled = _a[0], setSecureLoginEnabled = _a[1];
    var canUseSecureAlternative = React.useMemo(function () { var _a; return !cannotUseSecureAlternativeFamilies[(_a = ua.os) === null || _a === void 0 ? void 0 : _a.family]; }, [ua]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [!canUseSecureLogin && ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(exports.LoginFormWithExtensionNightly, __assign({}, state, { setSecureLoginEnabled: setSecureLoginEnabled, extensionPlatform: extensionPlatform })) })), (0, jsx_runtime_1.jsx)("div", { id: "hideLoginFormWithPassword", style: secureLoginEnabled ? { display: "none" } : undefined, children: (0, jsx_runtime_1.jsx)(exports.LoginFormWithPassword, __assign({}, state, { setSecureLoginEnabled: canUseSecureLogin ? setSecureLoginEnabled : undefined, canUseSecureAlternative: canUseSecureAlternative })) }), canUseSecureLogin && ((0, jsx_runtime_1.jsx)("div", { id: "hideLoginFormWithExtension", style: secureLoginEnabled ? undefined : { display: "none" }, children: (0, jsx_runtime_1.jsx)(exports.LoginFormWithExtension, __assign({}, state, { setSecureLoginEnabled: canUseSecureLogin ? setSecureLoginEnabled : undefined, extensionPlatform: extensionPlatform })) }))] }));
};
exports.LoginForm = LoginForm;
exports.LoginFormWithPassword = (0, react_router_1.withRouter)(function LoginFormWithPassword(state) {
    var _a = React.useState(""), username = _a[0], setUsername = _a[1];
    var _b = React.useState(""), password = _b[0], setPassword = _b[1];
    var _c = React.useState(false), logining = _c[0], setLogining = _c[1];
    var setSecureLoginEnabled = state.setSecureLoginEnabled;
    return ((0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Form, { loading: logining, onSubmit: function (e) {
            e.preventDefault();
            tryLogin(state, { username: username, password: password, remember: state.remember }, setLogining);
            return false;
        }, children: [(0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Form.Group, { id: "loginFormWithPassword", children: [(0, jsx_runtime_1.jsx)(semantic_ui_react_1.Form.Field, { inline: true, width: "5", children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Input, { label: i18n_1.default.username, value: username, onChange: function (e) { return setUsername(e.target.value); } }) }), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Form.Field, { inline: true, width: "5", children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Input, { label: i18n_1.default.password, type: "password", value: password, onChange: function (e) { return setPassword(e.target.value); } }) }), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Form.Field, { inline: true, width: "3", children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Checkbox, { checked: state.remember, onChange: function (_, _a) {
                                var checked = _a.checked;
                                return state.setRemember(Boolean(checked));
                            }, label: i18n_1.default.keepLoggedIn }) }), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Form.Button, { primary: true, type: "submit", width: "3", children: i18n_1.default.login })] }), (0, jsx_runtime_1.jsx)("p", { children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Button, { type: "button", onClick: function () { return (state.location.state ? state.history.goBack() : state.history.push("/")); }, children: i18n_1.default.back }) }), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Segment, { children: (0, jsx_runtime_1.jsx)("div", { style: descriptionTextStyle, children: i18n_1.default.loginNotice }) }), !!setSecureLoginEnabled && ((0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Segment, { children: [(0, jsx_runtime_1.jsxs)("div", { style: extensionTextStyle, children: [i18n_1.default.loginNoticeNoExtension, state.canUseSecureAlternative && i18n_1.default.loginBrowserRecommend] }), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Button, { type: "button", width: "3", primary: true, onClick: function () { return setSecureLoginEnabled(true); }, children: i18n_1.default.loginWithExtension })] })), (0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Segment, { children: [(0, jsx_runtime_1.jsx)("div", { style: cautionTitleTextStyle, children: i18n_1.default.loginCautionTitle }), (0, jsx_runtime_1.jsx)("div", { style: cautionTextStyle, children: i18n_1.default.loginCaution })] })] }));
});
var extensionUrl = {
    Firefox: "https://vrcprofile.com/addons/firefox/vrchat_profile-1.0.0-an+fx.xpi",
    Chrome: "https://chrome.google.com/webstore/detail/vrchat-profile/mimooabamaoeldhibjbbmdgndnhdiknh",
};
exports.LoginFormWithExtension = (0, react_router_1.withRouter)(function LoginFormWithExtension(state) {
    var _a = React.useState(""), authCookie = _a[0], setAuthCookie = _a[1];
    var _b = React.useState(false), logining = _b[0], setLogining = _b[1];
    var setSecureLoginEnabled = state.setSecureLoginEnabled;
    return ((0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Form, { loading: logining, onSubmit: function (e) {
            e.preventDefault();
            tryLogin(state, { authCookie: authCookie, remember: state.remember, autoLogoutMode: "extension" }, setLogining);
            return false;
        }, children: [(0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Form.Group, { id: "loginForm", children: [(0, jsx_runtime_1.jsx)(semantic_ui_react_1.Form.Field, { inline: true, width: "3", children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Checkbox, { checked: state.remember, onChange: function (_, _a) {
                                var checked = _a.checked;
                                return state.setRemember(Boolean(checked));
                            }, label: i18n_1.default.keepLoggedIn }) }), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Input, { id: "loginAuthcookie", style: { display: "none" }, value: authCookie, onChange: function (e) { return setAuthCookie(e.target.value); } }), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Button, { id: "getExtension", primary: true, type: "button", width: "3", as: "a", href: extensionUrl[state.extensionPlatform], rel: "noopener noreferrer", children: i18n_1.default.installExtension }), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Button, { id: "loginButton", primary: true, type: "button", width: "3", style: { display: "none" }, children: i18n_1.default.loginWithExtension }), (0, jsx_runtime_1.jsx)("div", { style: { display: "none" }, children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Form.Button, { id: "loginSubmit", primary: true, type: "submit", width: "3", style: { display: "none" }, children: i18n_1.default.login }) }), !!setSecureLoginEnabled && ((0, jsx_runtime_1.jsx)(semantic_ui_react_1.Button, { type: "button", width: "3", onClick: function () { return setSecureLoginEnabled(false); }, children: i18n_1.default.loginFallbackToNoExtension }))] }), (0, jsx_runtime_1.jsx)("p", { children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Button, { type: "button", onClick: function () { return (state.location.state ? state.history.goBack() : state.history.push("/")); }, children: i18n_1.default.back }) }), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Segment, { children: (0, jsx_runtime_1.jsx)("div", { style: descriptionTextStyle, children: i18n_1.default.loginNoticeWithExtension }) }), (0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Segment, { children: [(0, jsx_runtime_1.jsx)("div", { style: cautionTitleTextStyle, children: i18n_1.default.loginCautionTitle }), (0, jsx_runtime_1.jsx)("div", { style: cautionTextStyle, children: i18n_1.default.loginCaution })] })] }));
});
exports.LoginFormWithExtensionNightly = (0, react_router_1.withRouter)(function LoginFormWithExtensionNightly(state) {
    var _a = React.useState(""), authCookie = _a[0], setAuthCookie = _a[1];
    var _b = React.useState(false), logining = _b[0], setLogining = _b[1];
    return ((0, jsx_runtime_1.jsx)(semantic_ui_react_1.Form, { loading: logining, onSubmit: function (e) {
            e.preventDefault();
            tryLogin(state, { authCookie: authCookie, remember: state.remember, autoLogoutMode: "extension" }, setLogining);
            return false;
        }, children: (0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Form.Group, { id: "loginForm", children: [(0, jsx_runtime_1.jsx)(semantic_ui_react_1.Form.Field, { inline: true, width: "3", style: { display: "none" }, children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Checkbox, { checked: state.remember, onChange: function (_, _a) {
                            var checked = _a.checked;
                            return state.setRemember(Boolean(checked));
                        }, label: i18n_1.default.keepLoggedIn }) }), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Input, { id: "loginAuthcookie", style: { display: "none" }, value: authCookie, onChange: function (e) { return setAuthCookie(e.target.value); } }), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Button, { id: "loginButton", primary: true, type: "button", width: "3", style: { display: "none" }, children: i18n_1.default.loginWithExtension }), (0, jsx_runtime_1.jsx)("div", { style: { display: "none" }, children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Form.Button, { id: "loginSubmit", primary: true, type: "submit", width: "3", style: { display: "none" }, children: i18n_1.default.login }) })] }) }));
});
// const toBase64 = (str: string) => btoa(unescape(encodeURIComponent(str)));
var tryLogin = function (state, loginState, setLogining) { return __awaiter(void 0, void 0, void 0, function () {
    var result, user, profile, worlds, e_1;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 4, , 5]);
                setLogining(true);
                if (loginState.autoLogoutMode === "extension")
                    (0, sentry_1.captureException)(new Error("ext login [authCookie not null=".concat(loginState.authCookie != null, " length=").concat((_a = loginState.authCookie) === null || _a === void 0 ? void 0 : _a.length, "]")));
                return [4 /*yield*/, (0, api_1.login)(loginState)];
            case 1:
                result = _b.sent();
                if ("requiresTwoFactorAuth" in result) {
                    setLogining(false);
                    state.history.push("/login/2fa", state.location.state);
                    return [2 /*return*/];
                }
                user = result.user;
                return [4 /*yield*/, (0, api_1.fetchProfile)(result.user.id)];
            case 2:
                profile = _b.sent();
                state.setSelfUser(__assign(__assign({}, user), { profile: profile || { id: user.id, tags: [], privateTags: [] }, locationInfo: (0, util_1.parseUserLocation)(user) }));
                state.setLogined(true);
                return [4 /*yield*/, (0, api_1.fetchMyWorlds)()];
            case 3:
                worlds = _b.sent();
                state.addWorlds((0, util_1.toIdHash)(worlds));
                return [3 /*break*/, 5];
            case 4:
                e_1 = _b.sent();
                (0, sentry_1.captureException)(e_1);
                state.incrementErrorCount();
                alert("".concat(i18n_1.default.loginfailed, "\n").concat(e_1));
                setLogining(false);
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}); };
